import React, { useEffect, useState } from 'react';
import { useAdminTokenValidation } from '../hooks';
import { useIsAdminAuthenticated } from '../hooks';
import { LoadingScreen } from './index';

/**
 * Componente que protege las rutas de administración
 * Valida el token antes de renderizar el contenido
 */
const AdminTokenProtectedRoute = ({ children, fallback = null }) => {
  const isAuthenticated = useIsAdminAuthenticated();
  const { validateToken } = useAdminTokenValidation();
  const [isValidating, setIsValidating] = useState(true);
  const [isValid, setIsValid] = useState(false);

  useEffect(() => {
    const checkToken = async () => {
      if (!isAuthenticated) {
        setIsValidating(false);
        setIsValid(false);
        return;
      }

      try {
        const tokenValid = await validateToken();
        setIsValid(tokenValid);
      } catch (error) {
        console.error('Error validando token:', error);
        setIsValid(false);
      } finally {
        setIsValidating(false);
      }
    };

    checkToken();
  }, [isAuthenticated, validateToken]);

  // Mostrar loading mientras valida
  if (isValidating) {
    return <LoadingScreen message="Validando sesión..." />;
  }

  // Si no está autenticado o el token no es válido, mostrar fallback
  // Permitir acceso si hay token de teatro válido cuando se use este wrapper incidentalmente
  const theaterToken = typeof window !== 'undefined' ? localStorage.getItem('theaterAccessCodeToken') : null;
  if ((!isAuthenticated || !isValid) && !theaterToken) {
    return fallback || null;
  }

  // Token válido, renderizar contenido
  return children;
};

export default AdminTokenProtectedRoute; 